import { render, staticRenderFns } from "./TrafficFineDetail.vue?vue&type=template&id=7c043817&scoped=true&"
import script from "./TrafficFineDetail.vue?vue&type=script&lang=js&"
export * from "./TrafficFineDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrafficFineDetail.vue?vue&type=style&index=0&id=7c043817&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c043817",
  null
  
)

export default component.exports